export default {"src":"/_next/static/media/trustpilot_full_star.bb2e915e.svg","height":15,"width":15,"blurWidth":0,"blurHeight":0};